import { useAppSelector } from '../../../redux/store';
import { Hook } from 'jamespot-front-business';
import { LicenseHookListType } from 'jamespot-user-api';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const UILicenseRequired = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.color.orange};
`;

export const WidgetLicenseWrapper = ({ children, name }: { children: ReactNode; name: keyof LicenseHookListType }) => {
    const hook = useAppSelector((state) => Hook.selectors.selectHook(state, name));
    const intl = useIntl();

    if (hook && !hook.hasLicense) {
        return (
            <UILicenseRequired>
                {intl.formatMessage({ id: 'WIDGET_Missing_License' }, { label: 'label' in hook ? hook.label : '' })}
            </UILicenseRequired>
        );
    }

    return <>{children}</>;
};
